import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import "./homeV2.css";
import JjfLogo from "../../images/jjf-india-new-logo.png";
import HeaderV2 from "../../components/headerV2/HeaderV2";

/* ============================================================
   Shared chrome + theme for the "viral" (.jjfv2) pages
   ============================================================ */
export const HEART_PATH =
  "M12 21s-7-4.6-9.3-9C1.2 9 2.6 5.5 6 5.2c2-.2 3.4 1 4.4 2.4C11.4 9 12 10 12 10s.6-1 1.6-2.4C14.6 6.2 16 5 18 5.2c3.4.3 4.8 3.8 3.3 6.8C19 16.4 12 21 12 21Z";

export const Heart = ({ cls }) => (
  <svg className={cls} viewBox="0 0 24 24" fill="none">
    <path d={HEART_PATH} fill="currentColor" />
  </svg>
);

const scrollTop = () => window.scrollTo(10, 0);

/* ---------------------------------------------------------------- FOOTER */
function JjfFooter() {
  const [email, setEmail] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [nlErr, setNlErr] = useState("");
  const [nlOk, setNlOk] = useState("");

  const handleNewsletter = async (e) => {
    e.preventDefault();
    setNlErr("");
    setNlOk("");
    const trimmed = email.trim();
    if (!trimmed || !/^(?=.*[a-zA-Z])[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(trimmed)) {
      setNlErr("Please enter a valid Email ID.");
      return;
    }
    if (!isAgreed) {
      setNlErr("You must agree to the terms before subscribing.");
      return;
    }
    try {
      const response = await fetch(`https://marscms-api.mini91.com/api/newsletter`, {
        method: "POST",
        body: JSON.stringify({ email: trimmed, site: "6798f689e5b0d99195ac3eb8" }),
        headers: { "Content-Type": "application/json" },
      });
      if (response?.ok) {
        setNlOk("Thank you for subscribing to our newsletter!");
        setEmail("");
        setIsAgreed(false);
        setTimeout(() => setNlOk(""), 5000);
      } else {
        const err = await response.json();
        setNlErr(err.error || "Something went wrong. Please try again.");
      }
    } catch (err) {
      setNlErr("Something went wrong. Please try again.");
    }
  };

  return (
    <footer className="footer" id="footer">
      <div className="wrap footer-main">
        <div className="footer-grid">
          <div>
            <Link to="/" className="brand-foot" onClick={scrollTop}>
              <img src={JjfLogo} className="logo-img" alt="Jainam Jivika Foundation" />
            </Link>
            <p className="about-blurb">
              A social organisation committed to saving lives through Life Saver Army and community engagement - since 2017.
            </p>
            <div className="socials">
              <a href="https://www.instagram.com/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" /><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" /><circle cx="17.5" cy="6.5" r="1.2" fill="currentColor" /></svg></a>
              <a href="https://www.linkedin.com/company/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><svg viewBox="0 0 24 24" fill="none"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3.2 9.2h3.6V21H3.2V9.2Zm6 0h3.45v1.6h.05c.48-.9 1.66-1.85 3.42-1.85 3.66 0 4.33 2.3 4.33 5.3V21h-3.6v-5.3c0-1.26-.02-2.9-1.8-2.9-1.8 0-2.08 1.38-2.08 2.8V21H9.2V9.2Z" fill="currentColor" /></svg></a>
              <a href="https://www.facebook.com/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><svg viewBox="0 0 24 24" fill="none"><path d="M14 8h2V5h-2a3 3 0 0 0-3 3v2H9v3h2v6h3v-6h2l1-3h-3V8a1 1 0 0 1 1-1Z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" /></svg></a>
              <a href="https://www.youtube.com/@TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><svg viewBox="0 0 24 24" fill="none"><rect x="3" y="6" width="18" height="12" rx="3" stroke="currentColor" strokeWidth="1.8" /><path d="M10 9l5 3-5 3V9Z" fill="currentColor" /></svg></a>
              <a href="https://x.com/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="X"><svg viewBox="0 0 24 24" fill="none"><path d="M4 4l16 16M20 4 4 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" /></svg></a>
              <a href="https://www.threads.net/@TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="Threads"><svg viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M5.45 4.62C7 2.97 9.24 2 12.02 2c4.56 0 7.59 2.63 8.55 6.28a1 1 0 0 1-1.94.5C17.9 6.02 15.68 4 12.02 4c-2.29 0-3.98.79-5.11 1.99C5.77 7.2 5.14 8.91 5.14 10.88v2.25c0 1.96.63 3.67 1.77 4.88 1.13 1.2 2.82 1.99 5.11 1.99 1.65 0 2.96-.38 3.97-1 1.02-.63 1.62-1.46 1.79-2.41.2-1.1-.04-1.85-.46-2.39a3.3 3.3 0 0 0-.81-.74c-.14.75-.38 1.46-.74 2.01-1.34 2.04-3.91 2.21-5.6 1.54-.92-.37-1.7-1.36-1.95-2.44a3.1 3.1 0 0 1 .15-1.84c.26-.64.75-1.18 1.45-1.59.69-.41 1.72-.6 2.74-.63.61-.02 1.28.02 1.95.13-.14-.65-.38-1.14-.64-1.39-.49-.45-1.29-.76-2.1-.76-.77.01-1.43.31-1.83.94a1 1 0 0 1-1.69-1.06C9.09 7.04 10.47 6.51 11.76 6.5c1.27 0 2.58.47 3.47 1.3.9.84 1.28 2.21 1.38 3.45.88.39 1.7.95 2.3 1.75.79 1.03 1.12 2.36.84 3.95-.29 1.62-1.32 2.9-2.71 3.76-1.37.84-3.06 1.3-5.03 1.3-2.78 0-5.02-.98-6.56-2.62C3.91 17.74 3.14 15.51 3.14 13.13v-2.25c0-2.39.77-4.62 2.31-6.26Zm9.15 8.08a10.5 10.5 0 0 0-1.99-.19c-.89.03-1.51.2-1.77.35-.39.23-.55.46-.62.64a1.1 1.1 0 0 0-.04.63c.12.54.53.94.74 1.02 1.12.45 2.53.21 3.18-.78.24-.36.43-.96.5-1.67Z" fill="currentColor" /></svg></a>
              <a href="https://in.pinterest.com/TeamJJFIndia/" target="_blank" rel="noopener noreferrer" aria-label="Pinterest"><svg viewBox="0 0 24 24" fill="none"><path d="M12 2a10 10 0 0 0-3.64 19.32c-.09-.8-.17-2.03.03-2.9l1.17-4.97s-.3-.6-.3-1.48c0-1.39.8-2.42 1.8-2.42.85 0 1.26.64 1.26 1.4 0 .86-.54 2.14-.83 3.33-.24 1 .5 1.81 1.48 1.81 1.78 0 3.15-1.88 3.15-4.58 0-2.4-1.72-4.07-4.18-4.07-2.85 0-4.52 2.13-4.52 4.34 0 .86.33 1.78.74 2.28.08.1.09.18.07.28l-.28 1.12c-.04.18-.14.22-.33.13-1.22-.57-1.98-2.35-1.98-3.79 0-3.08 2.24-5.92 6.46-5.92 3.39 0 6.03 2.42 6.03 5.65 0 3.37-2.13 6.09-5.08 6.09-.99 0-1.92-.52-2.24-1.13l-.61 2.32c-.22.85-.81 1.91-1.21 2.56A10 10 0 1 0 12 2Z" fill="currentColor" /></svg></a>
              <a href="https://medium.com/@TeamJJFIndia" target="_blank" rel="noopener noreferrer" aria-label="Medium"><svg viewBox="0 0 24 24" fill="none"><ellipse cx="6.6" cy="12" rx="4.6" ry="5.3" fill="currentColor" /><ellipse cx="15.2" cy="12" rx="2.2" ry="5.3" fill="currentColor" /><ellipse cx="20.4" cy="12" rx="1" ry="5.3" fill="currentColor" /></svg></a>
              <a href="https://wa.me/919552895289" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><svg viewBox="0 0 24 24" fill="none"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" fill="currentColor" /></svg></a>
            </div>
          </div>

          <div>
            <h4>About Us</h4>
            <ul>
              <li><Link to="/about-us/who-we-are" onClick={scrollTop}>Who We Are?</Link></li>
              <li><Link to="/about-us/our-journey" onClick={scrollTop}>Our Journey</Link></li>
              <li><Link to="/about-us/leadership-team" onClick={scrollTop}>Leadership Team</Link></li>
              <li><Link to="/impact/success-stories" onClick={scrollTop}>Success Stories</Link></li>
              <li><Link to="/impact/testimonials" onClick={scrollTop}>Testimonials</Link></li>
              <li><Link to="/impact/achievements" onClick={scrollTop}>Achievements</Link></li>
              <li><Link to="/contact-us" onClick={scrollTop}>Contact Us</Link></li>
            </ul>
          </div>

          <div>
            <h4>Support Us</h4>
            <ul>
              <li><Link to="/legal-documents" onClick={scrollTop}>Legal Documents</Link></li>
              <li><Link to="/privacy-policy" onClick={scrollTop}>Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions" onClick={scrollTop}>Terms and Conditions</Link></li>
              <li><Link to="/cookie-policy" onClick={scrollTop}>Cookie Policy</Link></li>
              <li><Link to="/faqs" onClick={scrollTop}>FAQs</Link></li>
            </ul>
            <h4 style={{ marginTop: 28 }}>Our Initiative</h4>
            <ul>
              <li><Link to="/initiatives/life-saver-army" onClick={scrollTop}>LifeSaverArmy.com</Link></li>
            </ul>
          </div>

          <div className="news">
            <h4>Newsletter</h4>
            <p className="news-intro">Stay updated with our latest drives, camps and stories of impact.</p>
            <form className="news-form" onSubmit={handleNewsletter}>
              <input type="email" placeholder="Email ID" aria-label="Email address" value={email} onChange={(e) => setEmail(e.target.value)} />
              <button type="submit">Subscribe</button>
            </form>
            {nlErr && <div className="err">{nlErr}</div>}
            {nlOk && <div className="ok">{nlOk}</div>}
            <label className="agree">
              <input type="checkbox" style={{ marginTop: 3 }} checked={isAgreed} onChange={(e) => setIsAgreed(e.target.checked)} />
              I agree that my submitted data is being collected and stored.
            </label>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© 2017 - {new Date().getFullYear()} <a href="https://jjfindia.com/" target="_blank" rel="noopener noreferrer">Jainam Jivika Foundation</a>. All Rights Reserved.</span>
          <span>Seva · Community · Impact</span>
        </div>
      </div>
    </footer>
  );
}

/* ---------------------------------------------------------------- SHELL */
export default function JjfShell({ children }) {
  const rootRef = useRef(null);
  const [showIntro, setShowIntro] = useState(true);
  const [introExiting, setIntroExiting] = useState(false);
  const [revealed, setRevealed] = useState(false);
  const [showTop, setShowTop] = useState(false);

  /* intro splash (once per browser session) */
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    let seen = false;
    try {
      seen = sessionStorage.getItem("jjfv2_intro") === "1";
    } catch (e) {}
    if (reduce || seen) {
      setShowIntro(false);
      setRevealed(true);
      return;
    }
    document.body.style.overflow = "hidden";
    let t2;
    const finish = () => {
      setIntroExiting(true);
      setRevealed(true);
      try {
        sessionStorage.setItem("jjfv2_intro", "1");
      } catch (e) {}
      document.body.style.overflow = "";
      t2 = setTimeout(() => setShowIntro(false), 1000);
    };
    const t1 = setTimeout(finish, 1900);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
      document.body.style.overflow = "";
    };
  }, []);

  /* back-to-top visibility */
  useEffect(() => {
    const onScroll = () => setShowTop((p) => (p === (window.scrollY > 600) ? p : window.scrollY > 600));
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* vanilla interaction layer */
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    const fine = window.matchMedia("(hover:hover) and (pointer:fine)").matches;
    const cleanups = [];

    const revealIO = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in");
            revealIO.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    root.querySelectorAll(".reveal").forEach((el) => revealIO.observe(el));
    cleanups.push(() => revealIO.disconnect());

    const runCount = (el) => {
      const target = parseFloat(el.dataset.target);
      // data-decimals / data-suffix let a counter end on a short figure like "2.7K".
      const dec = parseInt(el.dataset.decimals || "0", 10);
      const suffix = el.dataset.suffix || "";
      const fmt = (v) => (dec ? v.toFixed(dec) : Math.round(v).toLocaleString("en-IN")) + suffix;
      const dur = 1600;
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / dur, 1);
        const eased = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(target * eased);
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = fmt(target);
      };
      requestAnimationFrame(tick);
    };
    const countIO = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            runCount(e.target);
            countIO.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    root.querySelectorAll(".count").forEach((el) => countIO.observe(el));
    cleanups.push(() => countIO.disconnect());

    const gItems = [...root.querySelectorAll(".gitem")];
    const galleryIO = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            const delay = (gItems.indexOf(e.target) % 4) * 90;
            setTimeout(() => e.target.classList.add("shown"), delay);
            galleryIO.unobserve(e.target);
          }
        });
      },
      { threshold: 0.18 }
    );
    gItems.forEach((g) => galleryIO.observe(g));
    cleanups.push(() => galleryIO.disconnect());

    if (!reduce) {
      const hero = root.querySelector(".hero");
      const mesh = root.querySelector(".hero-mesh");
      if (hero && mesh) {
        const onMove = (e) => {
          const r = hero.getBoundingClientRect();
          mesh.style.setProperty("--mx", (((e.clientX - r.left) / r.width) * 100).toFixed(1) + "%");
          mesh.style.setProperty("--my", (((e.clientY - r.top) / r.height) * 100).toFixed(1) + "%");
        };
        hero.addEventListener("pointermove", onMove);
        cleanups.push(() => hero.removeEventListener("pointermove", onMove));
        for (let i = 0; i < 14; i++) {
          const s = document.createElement("span");
          s.className = "hero-spark";
          const sz = 2 + Math.random() * 5;
          s.style.width = s.style.height = sz + "px";
          s.style.left = Math.random() * 100 + "%";
          s.style.bottom = -10 + Math.random() * 70 + "%";
          s.style.background = Math.random() > 0.5 ? "var(--amber)" : "var(--green-bright)";
          s.style.animationDuration = 5 + Math.random() * 7 + "s";
          s.style.animationDelay = -Math.random() * 8 + "s";
          mesh.appendChild(s);
        }
      }

      const band = root.querySelector(".impact .wrap");
      if (band) {
        for (let i = 0; i < 18; i++) {
          const s = document.createElement("span");
          s.className = "imp-spark";
          const sz = 2 + Math.random() * 5;
          s.style.width = s.style.height = sz + "px";
          s.style.left = Math.random() * 100 + "%";
          s.style.top = 18 + Math.random() * 72 + "%";
          s.style.background = Math.random() > 0.5 ? "rgba(246,178,75,.75)" : "rgba(255,255,255,.55)";
          s.style.animationDuration = 5 + Math.random() * 7 + "s";
          s.style.animationDelay = -Math.random() * 9 + "s";
          band.appendChild(s);
        }
      }

      const pEls = [...root.querySelectorAll(".float-badge")].map((el) => ({ el, speed: 0.12 + Math.random() * 0.06 }));
      const art = root.querySelector(".hero-art");
      const aboutMedia = root.querySelector(".about-media");
      if (art) pEls.push({ el: art, speed: 0.05 });
      if (aboutMedia) pEls.push({ el: aboutMedia, speed: 0.06 });
      let ticking = false;
      const parallax = () => {
        const y = window.scrollY;
        pEls.forEach((o) => {
          if (o.el) o.el.style.translate = "0 " + (-y * o.speed).toFixed(1) + "px";
        });
        ticking = false;
      };
      const onParaScroll = () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(parallax);
        }
      };
      window.addEventListener("scroll", onParaScroll, { passive: true });
      cleanups.push(() => window.removeEventListener("scroll", onParaScroll));
    }

    if (fine && !reduce) {
      const dot = root.querySelector(".cur-dot");
      const ring = root.querySelector(".cur-ring");
      if (dot && ring) {
        root.classList.add("cursor-on");
        document.body.classList.add("jjfv2-no-native-cursor");
        let mx = window.innerWidth / 2;
        let my = window.innerHeight / 2;
        let rx = mx;
        let ry = my;
        let ready = false;
        let raf;
        const onMove = (e) => {
          mx = e.clientX;
          my = e.clientY;
          dot.style.transform = `translate(${mx}px,${my}px) translate(-50%,-50%)`;
          if (!ready) {
            ready = true;
            root.classList.add("cursor-ready");
            rx = mx;
            ry = my;
          }
        };
        const loop = () => {
          rx += (mx - rx) * 0.18;
          ry += (my - ry) * 0.18;
          ring.style.transform = `translate(${rx}px,${ry}px) translate(-50%,-50%)`;
          raf = requestAnimationFrame(loop);
        };
        loop();
        const hoverSel = "a,button,.mvv-tab,.tdot,.gitem,.pillar,.init,.way,.nav-top";
        const onOver = (e) => {
          if (e.target.closest("input,textarea")) {
            root.classList.add("cur-text");
            root.classList.remove("cur-hover");
          } else if (e.target.closest(hoverSel)) {
            root.classList.add("cur-hover");
            root.classList.remove("cur-text");
          } else {
            root.classList.remove("cur-hover", "cur-text");
          }
        };
        const onDown = () => root.classList.add("cur-down");
        const onUp = () => root.classList.remove("cur-down");
        const onLeave = () => root.classList.remove("cursor-ready");
        const onEnter = () => root.classList.add("cursor-ready");
        window.addEventListener("mousemove", onMove, { passive: true });
        document.addEventListener("mouseover", onOver);
        window.addEventListener("mousedown", onDown);
        window.addEventListener("mouseup", onUp);
        document.addEventListener("mouseleave", onLeave);
        document.addEventListener("mouseenter", onEnter);
        cleanups.push(() => {
          cancelAnimationFrame(raf);
          window.removeEventListener("mousemove", onMove);
          document.removeEventListener("mouseover", onOver);
          window.removeEventListener("mousedown", onDown);
          window.removeEventListener("mouseup", onUp);
          document.removeEventListener("mouseleave", onLeave);
          document.removeEventListener("mouseenter", onEnter);
          document.body.classList.remove("jjfv2-no-native-cursor");
          root.classList.remove("cursor-on", "cursor-ready", "cur-hover", "cur-text", "cur-down");
        });
      }

      root.querySelectorAll(".pillar,.init,.way").forEach((card) => {
        const shine = document.createElement("span");
        shine.className = "tilt-shine";
        card.appendChild(shine);
        const onMove = (e) => {
          const r = card.getBoundingClientRect();
          const px = (e.clientX - r.left) / r.width;
          const py = (e.clientY - r.top) / r.height;
          card.style.transform = `perspective(800px) rotateX(${(0.5 - py) * 12}deg) rotateY(${(px - 0.5) * 12}deg) translateY(-8px)`;
          shine.style.setProperty("--sx", px * 100 + "%");
          shine.style.setProperty("--sy", py * 100 + "%");
        };
        const onLeave = () => {
          card.style.transform = "";
        };
        card.addEventListener("pointermove", onMove);
        card.addEventListener("pointerleave", onLeave);
        cleanups.push(() => {
          card.removeEventListener("pointermove", onMove);
          card.removeEventListener("pointerleave", onLeave);
        });
      });
    }

    const burst = (x, y) => {
      const n = reduce ? 0 : 20;
      for (let i = 0; i < n; i++) {
        const h = document.createElement("span");
        h.className = "jjfv2-heart" + (Math.random() > 0.5 ? " amber" : "");
        h.innerHTML = `<svg viewBox="0 0 24 24"><path d="${HEART_PATH}"/></svg>`;
        const ang = Math.random() * Math.PI * 2;
        const dist = 60 + Math.random() * 150;
        h.style.left = x + "px";
        h.style.top = y + "px";
        h.style.setProperty("--dx", (Math.cos(ang) * dist).toFixed(0) + "px");
        h.style.setProperty("--dy", (Math.sin(ang) * dist - 40).toFixed(0) + "px");
        h.style.setProperty("--sc", (0.5 + Math.random() * 1.1).toFixed(2));
        h.style.setProperty("--rot", Math.random() * 360 - 180 + "deg");
        h.style.animationDuration = 0.9 + Math.random() * 0.6 + "s";
        h.style.width = h.style.height = 14 + Math.random() * 16 + "px";
        document.body.appendChild(h);
        setTimeout(() => h.remove(), 1700);
      }
    };
    const burstHandlers = [];
    root.querySelectorAll("[data-burst]").forEach((el) => {
      const fn = () => {
        const r = el.getBoundingClientRect();
        burst(r.left + r.width / 2, r.top + r.height / 2);
      };
      el.addEventListener("click", fn);
      burstHandlers.push([el, fn]);
    });
    cleanups.push(() => burstHandlers.forEach(([el, fn]) => el.removeEventListener("click", fn)));

    return () => cleanups.forEach((fn) => fn());
  }, []);

  const goTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className={"jjfv2" + (revealed ? " revealed" : "")} ref={rootRef}>
      <div className="cur-ring" aria-hidden="true"></div>
      <div className="cur-dot" aria-hidden="true"></div>

      {showIntro && (
        <div className={"jjfv2-intro" + (introExiting ? " done" : "")} aria-hidden="true">
          <div className="curtain top"></div>
          <div className="curtain bot"></div>
          <div className="intro-core">
            <div className="intro-mark">
              <img src={JjfLogo} alt="Jainam Jivika Foundation" />
            </div>
            <div className="intro-name">
              <span className="ln">Jainam <b>Jivika</b></span>
              <span className="sub">Seva · Community · Impact</span>
            </div>
            <div className="intro-bar"><i></i></div>
          </div>
        </div>
      )}

      <HeaderV2 />

      {children}

      <JjfFooter />

      <button className={"fab totop" + (showTop ? " show" : "")} aria-label="Back to top" onClick={goTop}>
        <svg viewBox="0 0 24 24" fill="none"><path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
      </button>
    </div>
  );
}
